var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.30273 10.79L7.50273 12.44C8.5694 13.24 10.0361 13.24 11.1027 12.44L13.3027 10.79M10.9876 5.79004H4.30273C2.64588 5.79004 1.30273 7.13318 1.30273 8.79004V16.79C1.30273 18.4469 2.64588 19.79 4.30273 19.79H14.3027C15.9596 19.79 17.3027 18.4469 17.3027 16.79V8.79004C17.3027 8.55019 17.3027 8.35589 17.3027 8.35589",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.709 3.50879C15.709 3.09458 15.3732 2.75879 14.959 2.75879C14.5448 2.75879 14.209 3.09458 14.209 3.50879H15.709ZM14.959 5.00879H14.209C14.209 5.423 14.5448 5.75879 14.959 5.75879V5.00879ZM16.459 5.75879C16.8732 5.75879 17.209 5.423 17.209 5.00879C17.209 4.59458 16.8732 4.25879 16.459 4.25879V5.75879ZM18.209 5.00879C18.209 6.80371 16.7539 8.25879 14.959 8.25879V9.75879C17.5823 9.75879 19.709 7.63214 19.709 5.00879H18.209ZM14.959 8.25879C13.1641 8.25879 11.709 6.80371 11.709 5.00879H10.209C10.209 7.63214 12.3356 9.75879 14.959 9.75879V8.25879ZM11.709 5.00879C11.709 3.21386 13.1641 1.75879 14.959 1.75879V0.258789C12.3356 0.258789 10.209 2.38544 10.209 5.00879H11.709ZM14.959 1.75879C16.7539 1.75879 18.209 3.21386 18.209 5.00879H19.709C19.709 2.38544 17.5823 0.258789 14.959 0.258789V1.75879ZM14.209 3.50879V5.00879H15.709V3.50879H14.209ZM14.959 5.75879H16.459V4.25879H14.959V5.75879Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33);
export default __webpack_public_path__ + "static/media/group_33.df9854b4dadf8bbbb215e18459314b99.svg";
export { ForwardRef as ReactComponent };